import { gsap } from "../../node_modules/gsap/index.js";
import { ScrollTrigger } from "../../node_modules/gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

let circle1Pos = [-224.52299690246582, -100.03125];
let circle2Pos = [513.7501220703125, 551.0364990234375];
let circle3Pos = [687.1699829101562, 1.047760009765625];
let circle4Pos = [975.54248046875, 293.38409423828125];
let circle5Pos = [1203.4656982421875, -100.03125];

let targetX = 700;
let targetY = 230;

let triggerOpt = {
  trigger: "#do-the-right-thing",
  end: "bottom center",
  scrub: 0.5
}

let tl1 = gsap.timeline({
  scrollTrigger: triggerOpt
});
let tl2 = gsap.timeline({
  scrollTrigger: triggerOpt
});
let tl3 = gsap.timeline({
  scrollTrigger: triggerOpt
});
let tl4 = gsap.timeline({
  scrollTrigger: triggerOpt
});
let tl5 = gsap.timeline({
  scrollTrigger: triggerOpt
});

tl1.from("#circle-left-1", {x: 0,y: 0})
  .to("#circle-left-1", {x: targetX - circle1Pos[0],y: targetY - circle1Pos[1],ease: "power.inOut"})
  .to("#circle-left-1",{scale:2,y: targetY - circle1Pos[1]-135})

tl2.from("#circle-left-2", {x: 0,y: 0})
  .to("#circle-left-2", {x: targetX - circle2Pos[0],y: targetY - circle2Pos[1],ease: "power.inOut"})
  .to("#circle-left-2",{scale:2,y: targetY - circle2Pos[1]-135})

tl3.from("#circle-left-3", {x: 0,y: 0})
  .to("#circle-left-3", {x: targetX - circle3Pos[0],y: targetY - circle3Pos[1],ease: "power.inOut"})
  .to("#circle-left-3",{scale:2,y: targetY - circle3Pos[1]-135})

tl4.from("#circle-left-4", {x: 0,y: 0})
  .to("#circle-left-4", {x: targetX - circle4Pos[0],y: targetY - circle4Pos[1],ease: "power.inOut"})
  .to("#circle-left-4",{scale:2,y: targetY - circle4Pos[1]-135})

tl5.from("#circle-left-5", {x: 0,y: 0})
  .to("#circle-left-5", {x: targetX - circle5Pos[0],y: targetY - circle5Pos[1],ease: "power.inOut"})
  .to("#circle-left-5",{scale:2,y: targetY - circle5Pos[1]-135})
